// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api/v1/user_service.proto (package journal.api.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { State } from "./common_pb";
import { file_api_v1_common } from "./common_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import { file_google_api_client } from "../../google/api/client_pb";
import { file_google_api_field_behavior } from "../../google/api/field_behavior_pb";
import { file_google_api_resource } from "../../google/api/resource_pb";
import type { EmptySchema, FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/user_service.proto.
 */
export const file_api_v1_user_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_v1_common, file_google_api_annotations, file_google_api_client, file_google_api_field_behavior, file_google_api_resource, file_google_protobuf_empty, file_google_protobuf_field_mask, file_google_protobuf_timestamp]);

/**
 * @generated from message journal.api.v1.User
 */
export type User = Message<"journal.api.v1.User"> & {
  /**
   * The resource name of the user.
   * Format: users/{user}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The role of the user.
   *
   * @generated from field: journal.api.v1.User.Role role = 2;
   */
  role: User_Role;

  /**
   * Required. The unique username for login.
   *
   * @generated from field: string username = 3;
   */
  username: string;

  /**
   * Optional. The email address of the user.
   *
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * Optional. The display name of the user.
   *
   * @generated from field: string display_name = 5;
   */
  displayName: string;

  /**
   * Optional. The avatar URL of the user.
   *
   * @generated from field: string avatar_url = 6;
   */
  avatarUrl: string;

  /**
   * Optional. The description of the user.
   *
   * @generated from field: string description = 7;
   */
  description: string;

  /**
   * Input only. The password for the user.
   *
   * @generated from field: string password = 8;
   */
  password: string;

  /**
   * The state of the user.
   *
   * @generated from field: journal.api.v1.State state = 9;
   */
  state: State;

  /**
   * Output only. The creation timestamp.
   *
   * @generated from field: google.protobuf.Timestamp create_time = 10;
   */
  createTime?: Timestamp;

  /**
   * Output only. The last update timestamp.
   *
   * @generated from field: google.protobuf.Timestamp update_time = 11;
   */
  updateTime?: Timestamp;
};

/**
 * Describes the message journal.api.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 0);

/**
 * User role enumeration.
 *
 * @generated from enum journal.api.v1.User.Role
 */
export enum User_Role {
  /**
   * Unspecified role.
   *
   * @generated from enum value: ROLE_UNSPECIFIED = 0;
   */
  ROLE_UNSPECIFIED = 0,

  /**
   * Host role with full system access.
   *
   * @generated from enum value: HOST = 1;
   */
  HOST = 1,

  /**
   * Admin role with administrative privileges.
   *
   * @generated from enum value: ADMIN = 2;
   */
  ADMIN = 2,

  /**
   * Regular user role.
   *
   * @generated from enum value: USER = 3;
   */
  USER = 3,
}

/**
 * Describes the enum journal.api.v1.User.Role.
 */
export const User_RoleSchema: GenEnum<User_Role> = /*@__PURE__*/
  enumDesc(file_api_v1_user_service, 0, 0);

/**
 * @generated from message journal.api.v1.ListUsersRequest
 */
export type ListUsersRequest = Message<"journal.api.v1.ListUsersRequest"> & {
  /**
   * Optional. The maximum number of users to return.
   * The service may return fewer than this value.
   * If unspecified, at most 50 users will be returned.
   * The maximum value is 1000; values above 1000 will be coerced to 1000.
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * Optional. A page token, received from a previous `ListUsers` call.
   * Provide this to retrieve the subsequent page.
   *
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * Optional. Filter to apply to the list results.
   * Example: "username == 'steven'"
   * Supported operators: ==
   * Supported fields: username
   *
   * @generated from field: string filter = 3;
   */
  filter: string;

  /**
   * Optional. If true, show deleted users in the response.
   *
   * @generated from field: bool show_deleted = 4;
   */
  showDeleted: boolean;
};

/**
 * Describes the message journal.api.v1.ListUsersRequest.
 * Use `create(ListUsersRequestSchema)` to create a new message.
 */
export const ListUsersRequestSchema: GenMessage<ListUsersRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 1);

/**
 * @generated from message journal.api.v1.ListUsersResponse
 */
export type ListUsersResponse = Message<"journal.api.v1.ListUsersResponse"> & {
  /**
   * The list of users.
   *
   * @generated from field: repeated journal.api.v1.User users = 1;
   */
  users: User[];

  /**
   * A token that can be sent as `page_token` to retrieve the next page.
   * If this field is omitted, there are no subsequent pages.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * The total count of users (may be approximate).
   *
   * @generated from field: int32 total_size = 3;
   */
  totalSize: number;
};

/**
 * Describes the message journal.api.v1.ListUsersResponse.
 * Use `create(ListUsersResponseSchema)` to create a new message.
 */
export const ListUsersResponseSchema: GenMessage<ListUsersResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 2);

/**
 * @generated from message journal.api.v1.GetUserRequest
 */
export type GetUserRequest = Message<"journal.api.v1.GetUserRequest"> & {
  /**
   * Required. The resource name of the user.
   * Supports both numeric IDs and username strings:
   *   - users/{id}       (e.g., users/101)
   *   - users/{username} (e.g., users/steven)
   * Format: users/{id_or_username}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Optional. The fields to return in the response.
   * If not specified, all fields are returned.
   *
   * @generated from field: google.protobuf.FieldMask read_mask = 2;
   */
  readMask?: FieldMask;
};

/**
 * Describes the message journal.api.v1.GetUserRequest.
 * Use `create(GetUserRequestSchema)` to create a new message.
 */
export const GetUserRequestSchema: GenMessage<GetUserRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 3);

/**
 * @generated from message journal.api.v1.CreateUserRequest
 */
export type CreateUserRequest = Message<"journal.api.v1.CreateUserRequest"> & {
  /**
   * Required. The user to create.
   *
   * @generated from field: journal.api.v1.User user = 1;
   */
  user?: User;

  /**
   * Optional. The user ID to use for this user.
   * If empty, a unique ID will be generated.
   * Must match the pattern [a-z0-9-]+
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * Optional. If set, validate the request but don't actually create the user.
   *
   * @generated from field: bool validate_only = 3;
   */
  validateOnly: boolean;

  /**
   * Optional. An idempotency token that can be used to ensure that multiple
   * requests to create a user have the same result.
   *
   * @generated from field: string request_id = 4;
   */
  requestId: string;
};

/**
 * Describes the message journal.api.v1.CreateUserRequest.
 * Use `create(CreateUserRequestSchema)` to create a new message.
 */
export const CreateUserRequestSchema: GenMessage<CreateUserRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 4);

/**
 * @generated from message journal.api.v1.UpdateUserRequest
 */
export type UpdateUserRequest = Message<"journal.api.v1.UpdateUserRequest"> & {
  /**
   * Required. The user to update.
   *
   * @generated from field: journal.api.v1.User user = 1;
   */
  user?: User;

  /**
   * Required. The list of fields to update.
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;

  /**
   * Optional. If set to true, allows updating sensitive fields.
   *
   * @generated from field: bool allow_missing = 3;
   */
  allowMissing: boolean;
};

/**
 * Describes the message journal.api.v1.UpdateUserRequest.
 * Use `create(UpdateUserRequestSchema)` to create a new message.
 */
export const UpdateUserRequestSchema: GenMessage<UpdateUserRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 5);

/**
 * @generated from message journal.api.v1.DeleteUserRequest
 */
export type DeleteUserRequest = Message<"journal.api.v1.DeleteUserRequest"> & {
  /**
   * Required. The resource name of the user to delete.
   * Format: users/{user}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Optional. If set to true, the user will be deleted even if they have associated data.
   *
   * @generated from field: bool force = 2;
   */
  force: boolean;
};

/**
 * Describes the message journal.api.v1.DeleteUserRequest.
 * Use `create(DeleteUserRequestSchema)` to create a new message.
 */
export const DeleteUserRequestSchema: GenMessage<DeleteUserRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 6);

/**
 * User statistics messages
 *
 * @generated from message journal.api.v1.UserStats
 */
export type UserStats = Message<"journal.api.v1.UserStats"> & {
  /**
   * The resource name of the user whose stats these are.
   * Format: users/{user}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The stats of memo types.
   *
   * @generated from field: journal.api.v1.UserStats.MemoTypeStats memo_type_stats = 2;
   */
  memoTypeStats?: UserStats_MemoTypeStats;

  /**
   * The count of tags.
   *
   * @generated from field: map<string, int32> tag_count = 3;
   */
  tagCount: { [key: string]: number };

  /**
   * The count of tickers.
   *
   * @generated from field: map<string, int32> ticker_count = 6;
   */
  tickerCount: { [key: string]: number };

  /**
   * The pinned memos of the user.
   *
   * @generated from field: repeated string pinned_memos = 4;
   */
  pinnedMemos: string[];

  /**
   * Total memo count.
   *
   * @generated from field: int32 total_memo_count = 5;
   */
  totalMemoCount: number;
};

/**
 * Describes the message journal.api.v1.UserStats.
 * Use `create(UserStatsSchema)` to create a new message.
 */
export const UserStatsSchema: GenMessage<UserStats> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 7);

/**
 * Memo type statistics.
 *
 * @generated from message journal.api.v1.UserStats.MemoTypeStats
 */
export type UserStats_MemoTypeStats = Message<"journal.api.v1.UserStats.MemoTypeStats"> & {
  /**
   * @generated from field: int32 link_count = 1;
   */
  linkCount: number;

  /**
   * @generated from field: int32 code_count = 2;
   */
  codeCount: number;

  /**
   * @generated from field: int32 todo_count = 3;
   */
  todoCount: number;

  /**
   * @generated from field: int32 undo_count = 4;
   */
  undoCount: number;
};

/**
 * Describes the message journal.api.v1.UserStats.MemoTypeStats.
 * Use `create(UserStats_MemoTypeStatsSchema)` to create a new message.
 */
export const UserStats_MemoTypeStatsSchema: GenMessage<UserStats_MemoTypeStats> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 7, 0);

/**
 * @generated from message journal.api.v1.GetUserStatsRequest
 */
export type GetUserStatsRequest = Message<"journal.api.v1.GetUserStatsRequest"> & {
  /**
   * Required. The resource name of the user.
   * Format: users/{user}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message journal.api.v1.GetUserStatsRequest.
 * Use `create(GetUserStatsRequestSchema)` to create a new message.
 */
export const GetUserStatsRequestSchema: GenMessage<GetUserStatsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 8);

/**
 * This endpoint doesn't take any parameters.
 *
 * @generated from message journal.api.v1.ListAllUserStatsRequest
 */
export type ListAllUserStatsRequest = Message<"journal.api.v1.ListAllUserStatsRequest"> & {
};

/**
 * Describes the message journal.api.v1.ListAllUserStatsRequest.
 * Use `create(ListAllUserStatsRequestSchema)` to create a new message.
 */
export const ListAllUserStatsRequestSchema: GenMessage<ListAllUserStatsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 9);

/**
 * @generated from message journal.api.v1.ListAllUserStatsResponse
 */
export type ListAllUserStatsResponse = Message<"journal.api.v1.ListAllUserStatsResponse"> & {
  /**
   * The list of user statistics.
   *
   * @generated from field: repeated journal.api.v1.UserStats stats = 1;
   */
  stats: UserStats[];
};

/**
 * Describes the message journal.api.v1.ListAllUserStatsResponse.
 * Use `create(ListAllUserStatsResponseSchema)` to create a new message.
 */
export const ListAllUserStatsResponseSchema: GenMessage<ListAllUserStatsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 10);

/**
 * User settings message
 *
 * @generated from message journal.api.v1.UserSetting
 */
export type UserSetting = Message<"journal.api.v1.UserSetting"> & {
  /**
   * The name of the user setting.
   * Format: users/{user}/settings/{setting}, {setting} is the key for the setting.
   * For example, "users/123/settings/GENERAL" for general settings.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from oneof journal.api.v1.UserSetting.value
   */
  value: {
    /**
     * @generated from field: journal.api.v1.UserSetting.GeneralSetting general_setting = 2;
     */
    value: UserSetting_GeneralSetting;
    case: "generalSetting";
  } | {
    /**
     * @generated from field: journal.api.v1.UserSetting.WebhooksSetting webhooks_setting = 5;
     */
    value: UserSetting_WebhooksSetting;
    case: "webhooksSetting";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message journal.api.v1.UserSetting.
 * Use `create(UserSettingSchema)` to create a new message.
 */
export const UserSettingSchema: GenMessage<UserSetting> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 11);

/**
 * General user settings configuration.
 *
 * @generated from message journal.api.v1.UserSetting.GeneralSetting
 */
export type UserSetting_GeneralSetting = Message<"journal.api.v1.UserSetting.GeneralSetting"> & {
  /**
   * The preferred locale of the user.
   *
   * @generated from field: string locale = 1;
   */
  locale: string;

  /**
   * ❌ REMOVED: memo_visibility field (v0.66.0 - all memos are private)
   * The preferred theme of the user.
   * This references a CSS file in the web/public/themes/ directory.
   * If not set, the default theme will be used.
   *
   * @generated from field: string theme = 4;
   */
  theme: string;

  /**
   * The color scheme for price changes.
   * "green-up-red-down" (US standard) or "red-up-green-down" (China standard).
   *
   * @generated from field: string color_scheme = 5;
   */
  colorScheme: string;

  /**
   * The user's timezone preference (v0.65.0).
   * Uses IANA timezone database names (e.g., "Asia/Shanghai", "America/New_York").
   * Auto-detected from browser on first load, can be manually changed in settings.
   *
   * @generated from field: string timezone = 6;
   */
  timezone: string;
};

/**
 * Describes the message journal.api.v1.UserSetting.GeneralSetting.
 * Use `create(UserSetting_GeneralSettingSchema)` to create a new message.
 */
export const UserSetting_GeneralSettingSchema: GenMessage<UserSetting_GeneralSetting> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 11, 0);

/**
 * User webhooks configuration.
 *
 * @generated from message journal.api.v1.UserSetting.WebhooksSetting
 */
export type UserSetting_WebhooksSetting = Message<"journal.api.v1.UserSetting.WebhooksSetting"> & {
  /**
   * List of user webhooks.
   *
   * @generated from field: repeated journal.api.v1.UserWebhook webhooks = 1;
   */
  webhooks: UserWebhook[];
};

/**
 * Describes the message journal.api.v1.UserSetting.WebhooksSetting.
 * Use `create(UserSetting_WebhooksSettingSchema)` to create a new message.
 */
export const UserSetting_WebhooksSettingSchema: GenMessage<UserSetting_WebhooksSetting> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 11, 1);

/**
 * Enumeration of user setting keys.
 *
 * @generated from enum journal.api.v1.UserSetting.Key
 */
export enum UserSetting_Key {
  /**
   * @generated from enum value: KEY_UNSPECIFIED = 0;
   */
  KEY_UNSPECIFIED = 0,

  /**
   * GENERAL is the key for general user settings.
   *
   * @generated from enum value: GENERAL = 1;
   */
  GENERAL = 1,

  /**
   * WEBHOOKS is the key for user webhooks.
   *
   * @generated from enum value: WEBHOOKS = 4;
   */
  WEBHOOKS = 4,
}

/**
 * Describes the enum journal.api.v1.UserSetting.Key.
 */
export const UserSetting_KeySchema: GenEnum<UserSetting_Key> = /*@__PURE__*/
  enumDesc(file_api_v1_user_service, 11, 0);

/**
 * @generated from message journal.api.v1.GetUserSettingRequest
 */
export type GetUserSettingRequest = Message<"journal.api.v1.GetUserSettingRequest"> & {
  /**
   * Required. The resource name of the user setting.
   * Format: users/{user}/settings/{setting}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message journal.api.v1.GetUserSettingRequest.
 * Use `create(GetUserSettingRequestSchema)` to create a new message.
 */
export const GetUserSettingRequestSchema: GenMessage<GetUserSettingRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 12);

/**
 * @generated from message journal.api.v1.UpdateUserSettingRequest
 */
export type UpdateUserSettingRequest = Message<"journal.api.v1.UpdateUserSettingRequest"> & {
  /**
   * Required. The user setting to update.
   *
   * @generated from field: journal.api.v1.UserSetting setting = 1;
   */
  setting?: UserSetting;

  /**
   * Required. The list of fields to update.
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message journal.api.v1.UpdateUserSettingRequest.
 * Use `create(UpdateUserSettingRequestSchema)` to create a new message.
 */
export const UpdateUserSettingRequestSchema: GenMessage<UpdateUserSettingRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 13);

/**
 * Request message for ListUserSettings method.
 *
 * @generated from message journal.api.v1.ListUserSettingsRequest
 */
export type ListUserSettingsRequest = Message<"journal.api.v1.ListUserSettingsRequest"> & {
  /**
   * Required. The parent resource whose settings will be listed.
   * Format: users/{user}
   *
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * Optional. The maximum number of settings to return.
   * The service may return fewer than this value.
   * If unspecified, at most 50 settings will be returned.
   * The maximum value is 1000; values above 1000 will be coerced to 1000.
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * Optional. A page token, received from a previous `ListUserSettings` call.
   * Provide this to retrieve the subsequent page.
   *
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message journal.api.v1.ListUserSettingsRequest.
 * Use `create(ListUserSettingsRequestSchema)` to create a new message.
 */
export const ListUserSettingsRequestSchema: GenMessage<ListUserSettingsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 14);

/**
 * Response message for ListUserSettings method.
 *
 * @generated from message journal.api.v1.ListUserSettingsResponse
 */
export type ListUserSettingsResponse = Message<"journal.api.v1.ListUserSettingsResponse"> & {
  /**
   * The list of user settings.
   *
   * @generated from field: repeated journal.api.v1.UserSetting settings = 1;
   */
  settings: UserSetting[];

  /**
   * A token that can be sent as `page_token` to retrieve the next page.
   * If this field is omitted, there are no subsequent pages.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * The total count of settings (may be approximate).
   *
   * @generated from field: int32 total_size = 3;
   */
  totalSize: number;
};

/**
 * Describes the message journal.api.v1.ListUserSettingsResponse.
 * Use `create(ListUserSettingsResponseSchema)` to create a new message.
 */
export const ListUserSettingsResponseSchema: GenMessage<ListUserSettingsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 15);

/**
 * PersonalAccessToken represents a long-lived token for API/script access.
 * PATs are distinct from short-lived JWT access tokens used for session authentication.
 *
 * @generated from message journal.api.v1.PersonalAccessToken
 */
export type PersonalAccessToken = Message<"journal.api.v1.PersonalAccessToken"> & {
  /**
   * The resource name of the personal access token.
   * Format: users/{user}/personalAccessTokens/{personal_access_token}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The description of the token.
   *
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * Output only. The creation timestamp.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp;

  /**
   * Optional. The expiration timestamp.
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: Timestamp;

  /**
   * Output only. The last used timestamp.
   *
   * @generated from field: google.protobuf.Timestamp last_used_at = 5;
   */
  lastUsedAt?: Timestamp;

  /**
   * Scopes assigned to this token.
   * Empty array or ["admin"] means full admin access.
   *
   * @generated from field: repeated string scopes = 6;
   */
  scopes: string[];
};

/**
 * Describes the message journal.api.v1.PersonalAccessToken.
 * Use `create(PersonalAccessTokenSchema)` to create a new message.
 */
export const PersonalAccessTokenSchema: GenMessage<PersonalAccessToken> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 16);

/**
 * @generated from message journal.api.v1.ListPersonalAccessTokensRequest
 */
export type ListPersonalAccessTokensRequest = Message<"journal.api.v1.ListPersonalAccessTokensRequest"> & {
  /**
   * Required. The parent resource whose personal access tokens will be listed.
   * Format: users/{user}
   *
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * Optional. The maximum number of tokens to return.
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * Optional. A page token for pagination.
   *
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message journal.api.v1.ListPersonalAccessTokensRequest.
 * Use `create(ListPersonalAccessTokensRequestSchema)` to create a new message.
 */
export const ListPersonalAccessTokensRequestSchema: GenMessage<ListPersonalAccessTokensRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 17);

/**
 * @generated from message journal.api.v1.ListPersonalAccessTokensResponse
 */
export type ListPersonalAccessTokensResponse = Message<"journal.api.v1.ListPersonalAccessTokensResponse"> & {
  /**
   * The list of personal access tokens.
   *
   * @generated from field: repeated journal.api.v1.PersonalAccessToken personal_access_tokens = 1;
   */
  personalAccessTokens: PersonalAccessToken[];

  /**
   * A token for the next page of results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * The total count of personal access tokens.
   *
   * @generated from field: int32 total_size = 3;
   */
  totalSize: number;
};

/**
 * Describes the message journal.api.v1.ListPersonalAccessTokensResponse.
 * Use `create(ListPersonalAccessTokensResponseSchema)` to create a new message.
 */
export const ListPersonalAccessTokensResponseSchema: GenMessage<ListPersonalAccessTokensResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 18);

/**
 * @generated from message journal.api.v1.CreatePersonalAccessTokenRequest
 */
export type CreatePersonalAccessTokenRequest = Message<"journal.api.v1.CreatePersonalAccessTokenRequest"> & {
  /**
   * Required. The parent resource where this token will be created.
   * Format: users/{user}
   *
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * Optional. Description of the personal access token.
   *
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * Optional. Expiration duration in days (0 = never expires).
   *
   * @generated from field: int32 expires_in_days = 3;
   */
  expiresInDays: number;

  /**
   * Optional. Scopes for this token.
   * If not specified, defaults to ["admin"] for backward compatibility.
   * Valid values: "read", "write", "delete", "settings", "admin"
   *
   * @generated from field: repeated string scopes = 4;
   */
  scopes: string[];
};

/**
 * Describes the message journal.api.v1.CreatePersonalAccessTokenRequest.
 * Use `create(CreatePersonalAccessTokenRequestSchema)` to create a new message.
 */
export const CreatePersonalAccessTokenRequestSchema: GenMessage<CreatePersonalAccessTokenRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 19);

/**
 * @generated from message journal.api.v1.CreatePersonalAccessTokenResponse
 */
export type CreatePersonalAccessTokenResponse = Message<"journal.api.v1.CreatePersonalAccessTokenResponse"> & {
  /**
   * The personal access token metadata.
   *
   * @generated from field: journal.api.v1.PersonalAccessToken personal_access_token = 1;
   */
  personalAccessToken?: PersonalAccessToken;

  /**
   * The actual token value - only returned on creation.
   * This is the only time the token value will be visible.
   *
   * @generated from field: string token = 2;
   */
  token: string;
};

/**
 * Describes the message journal.api.v1.CreatePersonalAccessTokenResponse.
 * Use `create(CreatePersonalAccessTokenResponseSchema)` to create a new message.
 */
export const CreatePersonalAccessTokenResponseSchema: GenMessage<CreatePersonalAccessTokenResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 20);

/**
 * @generated from message journal.api.v1.DeletePersonalAccessTokenRequest
 */
export type DeletePersonalAccessTokenRequest = Message<"journal.api.v1.DeletePersonalAccessTokenRequest"> & {
  /**
   * Required. The resource name of the personal access token to delete.
   * Format: users/{user}/personalAccessTokens/{personal_access_token}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message journal.api.v1.DeletePersonalAccessTokenRequest.
 * Use `create(DeletePersonalAccessTokenRequestSchema)` to create a new message.
 */
export const DeletePersonalAccessTokenRequestSchema: GenMessage<DeletePersonalAccessTokenRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 21);

/**
 * UserWebhook represents a webhook owned by a user.
 *
 * @generated from message journal.api.v1.UserWebhook
 */
export type UserWebhook = Message<"journal.api.v1.UserWebhook"> & {
  /**
   * The name of the webhook.
   * Format: users/{user}/webhooks/{webhook}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The URL to send the webhook to.
   *
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * Optional. Human-readable name for the webhook.
   *
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * The creation time of the webhook.
   *
   * @generated from field: google.protobuf.Timestamp create_time = 4;
   */
  createTime?: Timestamp;

  /**
   * The last update time of the webhook.
   *
   * @generated from field: google.protobuf.Timestamp update_time = 5;
   */
  updateTime?: Timestamp;
};

/**
 * Describes the message journal.api.v1.UserWebhook.
 * Use `create(UserWebhookSchema)` to create a new message.
 */
export const UserWebhookSchema: GenMessage<UserWebhook> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 22);

/**
 * @generated from message journal.api.v1.ListUserWebhooksRequest
 */
export type ListUserWebhooksRequest = Message<"journal.api.v1.ListUserWebhooksRequest"> & {
  /**
   * The parent user resource.
   * Format: users/{user}
   *
   * @generated from field: string parent = 1;
   */
  parent: string;
};

/**
 * Describes the message journal.api.v1.ListUserWebhooksRequest.
 * Use `create(ListUserWebhooksRequestSchema)` to create a new message.
 */
export const ListUserWebhooksRequestSchema: GenMessage<ListUserWebhooksRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 23);

/**
 * @generated from message journal.api.v1.ListUserWebhooksResponse
 */
export type ListUserWebhooksResponse = Message<"journal.api.v1.ListUserWebhooksResponse"> & {
  /**
   * The list of webhooks.
   *
   * @generated from field: repeated journal.api.v1.UserWebhook webhooks = 1;
   */
  webhooks: UserWebhook[];
};

/**
 * Describes the message journal.api.v1.ListUserWebhooksResponse.
 * Use `create(ListUserWebhooksResponseSchema)` to create a new message.
 */
export const ListUserWebhooksResponseSchema: GenMessage<ListUserWebhooksResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 24);

/**
 * @generated from message journal.api.v1.CreateUserWebhookRequest
 */
export type CreateUserWebhookRequest = Message<"journal.api.v1.CreateUserWebhookRequest"> & {
  /**
   * The parent user resource.
   * Format: users/{user}
   *
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * The webhook to create.
   *
   * @generated from field: journal.api.v1.UserWebhook webhook = 2;
   */
  webhook?: UserWebhook;
};

/**
 * Describes the message journal.api.v1.CreateUserWebhookRequest.
 * Use `create(CreateUserWebhookRequestSchema)` to create a new message.
 */
export const CreateUserWebhookRequestSchema: GenMessage<CreateUserWebhookRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 25);

/**
 * @generated from message journal.api.v1.UpdateUserWebhookRequest
 */
export type UpdateUserWebhookRequest = Message<"journal.api.v1.UpdateUserWebhookRequest"> & {
  /**
   * The webhook to update.
   *
   * @generated from field: journal.api.v1.UserWebhook webhook = 1;
   */
  webhook?: UserWebhook;

  /**
   * The list of fields to update.
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message journal.api.v1.UpdateUserWebhookRequest.
 * Use `create(UpdateUserWebhookRequestSchema)` to create a new message.
 */
export const UpdateUserWebhookRequestSchema: GenMessage<UpdateUserWebhookRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 26);

/**
 * @generated from message journal.api.v1.DeleteUserWebhookRequest
 */
export type DeleteUserWebhookRequest = Message<"journal.api.v1.DeleteUserWebhookRequest"> & {
  /**
   * The name of the webhook to delete.
   * Format: users/{user}/webhooks/{webhook}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message journal.api.v1.DeleteUserWebhookRequest.
 * Use `create(DeleteUserWebhookRequestSchema)` to create a new message.
 */
export const DeleteUserWebhookRequestSchema: GenMessage<DeleteUserWebhookRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 27);

/**
 * @generated from message journal.api.v1.UserNotification
 */
export type UserNotification = Message<"journal.api.v1.UserNotification"> & {
  /**
   * The resource name of the notification.
   * Format: users/{user}/notifications/{notification}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The sender of the notification.
   * Format: users/{user}
   *
   * @generated from field: string sender = 2;
   */
  sender: string;

  /**
   * The status of the notification.
   *
   * @generated from field: journal.api.v1.UserNotification.Status status = 3;
   */
  status: UserNotification_Status;

  /**
   * The creation timestamp.
   *
   * @generated from field: google.protobuf.Timestamp create_time = 4;
   */
  createTime?: Timestamp;

  /**
   * The type of the notification.
   *
   * @generated from field: journal.api.v1.UserNotification.Type type = 5;
   */
  type: UserNotification_Type;

  /**
   * The activity ID associated with this notification.
   *
   * @generated from field: optional int32 activity_id = 6;
   */
  activityId?: number;

  /**
   * Optional title/content for this notification (e.g., JSON string with ticker symbol, sentiment, etc).
   *
   * @generated from field: string title = 7;
   */
  title: string;
};

/**
 * Describes the message journal.api.v1.UserNotification.
 * Use `create(UserNotificationSchema)` to create a new message.
 */
export const UserNotificationSchema: GenMessage<UserNotification> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 28);

/**
 * @generated from enum journal.api.v1.UserNotification.Status
 */
export enum UserNotification_Status {
  /**
   * @generated from enum value: STATUS_UNSPECIFIED = 0;
   */
  STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: UNREAD = 1;
   */
  UNREAD = 1,

  /**
   * @generated from enum value: ARCHIVED = 2;
   */
  ARCHIVED = 2,
}

/**
 * Describes the enum journal.api.v1.UserNotification.Status.
 */
export const UserNotification_StatusSchema: GenEnum<UserNotification_Status> = /*@__PURE__*/
  enumDesc(file_api_v1_user_service, 28, 0);

/**
 * @generated from enum journal.api.v1.UserNotification.Type
 */
export enum UserNotification_Type {
  /**
   * @generated from enum value: TYPE_UNSPECIFIED = 0;
   */
  TYPE_UNSPECIFIED = 0,

  /**
   * DEPRECATED: v0.73.0 - Comment feature removed
   *
   * @generated from enum value: MEMO_COMMENT = 1 [deprecated = true];
   * @deprecated
   */
  MEMO_COMMENT = 1,

  /**
   * @generated from enum value: AI_ANALYSIS = 2;
   */
  AI_ANALYSIS = 2,

  /**
   * @generated from enum value: TRIGGER_SCHEDULER = 3;
   */
  TRIGGER_SCHEDULER = 3,
}

/**
 * Describes the enum journal.api.v1.UserNotification.Type.
 */
export const UserNotification_TypeSchema: GenEnum<UserNotification_Type> = /*@__PURE__*/
  enumDesc(file_api_v1_user_service, 28, 1);

/**
 * @generated from message journal.api.v1.ListUserNotificationsRequest
 */
export type ListUserNotificationsRequest = Message<"journal.api.v1.ListUserNotificationsRequest"> & {
  /**
   * The parent user resource.
   * Format: users/{user}
   *
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;

  /**
   * @generated from field: string filter = 4;
   */
  filter: string;
};

/**
 * Describes the message journal.api.v1.ListUserNotificationsRequest.
 * Use `create(ListUserNotificationsRequestSchema)` to create a new message.
 */
export const ListUserNotificationsRequestSchema: GenMessage<ListUserNotificationsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 29);

/**
 * @generated from message journal.api.v1.ListUserNotificationsResponse
 */
export type ListUserNotificationsResponse = Message<"journal.api.v1.ListUserNotificationsResponse"> & {
  /**
   * @generated from field: repeated journal.api.v1.UserNotification notifications = 1;
   */
  notifications: UserNotification[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message journal.api.v1.ListUserNotificationsResponse.
 * Use `create(ListUserNotificationsResponseSchema)` to create a new message.
 */
export const ListUserNotificationsResponseSchema: GenMessage<ListUserNotificationsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 30);

/**
 * @generated from message journal.api.v1.UpdateUserNotificationRequest
 */
export type UpdateUserNotificationRequest = Message<"journal.api.v1.UpdateUserNotificationRequest"> & {
  /**
   * @generated from field: journal.api.v1.UserNotification notification = 1;
   */
  notification?: UserNotification;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message journal.api.v1.UpdateUserNotificationRequest.
 * Use `create(UpdateUserNotificationRequestSchema)` to create a new message.
 */
export const UpdateUserNotificationRequestSchema: GenMessage<UpdateUserNotificationRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 31);

/**
 * @generated from message journal.api.v1.DeleteUserNotificationRequest
 */
export type DeleteUserNotificationRequest = Message<"journal.api.v1.DeleteUserNotificationRequest"> & {
  /**
   * Format: users/{user}/notifications/{notification}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message journal.api.v1.DeleteUserNotificationRequest.
 * Use `create(DeleteUserNotificationRequestSchema)` to create a new message.
 */
export const DeleteUserNotificationRequestSchema: GenMessage<DeleteUserNotificationRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_user_service, 32);

/**
 * @generated from service journal.api.v1.UserService
 */
export const UserService: GenService<{
  /**
   * ListUsers returns a list of users.
   *
   * @generated from rpc journal.api.v1.UserService.ListUsers
   */
  listUsers: {
    methodKind: "unary";
    input: typeof ListUsersRequestSchema;
    output: typeof ListUsersResponseSchema;
  },
  /**
   * GetUser gets a user by ID or username.
   * Supports both numeric IDs and username strings:
   *   - users/{id}       (e.g., users/101)
   *   - users/{username} (e.g., users/steven)
   *
   * @generated from rpc journal.api.v1.UserService.GetUser
   */
  getUser: {
    methodKind: "unary";
    input: typeof GetUserRequestSchema;
    output: typeof UserSchema;
  },
  /**
   * CreateUser creates a new user.
   *
   * @generated from rpc journal.api.v1.UserService.CreateUser
   */
  createUser: {
    methodKind: "unary";
    input: typeof CreateUserRequestSchema;
    output: typeof UserSchema;
  },
  /**
   * UpdateUser updates a user.
   *
   * @generated from rpc journal.api.v1.UserService.UpdateUser
   */
  updateUser: {
    methodKind: "unary";
    input: typeof UpdateUserRequestSchema;
    output: typeof UserSchema;
  },
  /**
   * DeleteUser deletes a user.
   *
   * @generated from rpc journal.api.v1.UserService.DeleteUser
   */
  deleteUser: {
    methodKind: "unary";
    input: typeof DeleteUserRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * ListAllUserStats returns statistics for all users.
   *
   * @generated from rpc journal.api.v1.UserService.ListAllUserStats
   */
  listAllUserStats: {
    methodKind: "unary";
    input: typeof ListAllUserStatsRequestSchema;
    output: typeof ListAllUserStatsResponseSchema;
  },
  /**
   * GetUserStats returns statistics for a specific user.
   *
   * @generated from rpc journal.api.v1.UserService.GetUserStats
   */
  getUserStats: {
    methodKind: "unary";
    input: typeof GetUserStatsRequestSchema;
    output: typeof UserStatsSchema;
  },
  /**
   * GetUserSetting returns the user setting.
   *
   * @generated from rpc journal.api.v1.UserService.GetUserSetting
   */
  getUserSetting: {
    methodKind: "unary";
    input: typeof GetUserSettingRequestSchema;
    output: typeof UserSettingSchema;
  },
  /**
   * UpdateUserSetting updates the user setting.
   *
   * @generated from rpc journal.api.v1.UserService.UpdateUserSetting
   */
  updateUserSetting: {
    methodKind: "unary";
    input: typeof UpdateUserSettingRequestSchema;
    output: typeof UserSettingSchema;
  },
  /**
   * ListUserSettings returns a list of user settings.
   *
   * @generated from rpc journal.api.v1.UserService.ListUserSettings
   */
  listUserSettings: {
    methodKind: "unary";
    input: typeof ListUserSettingsRequestSchema;
    output: typeof ListUserSettingsResponseSchema;
  },
  /**
   * ListPersonalAccessTokens returns a list of Personal Access Tokens (PATs) for a user.
   * PATs are long-lived tokens for API/script access, distinct from short-lived JWT access tokens.
   *
   * @generated from rpc journal.api.v1.UserService.ListPersonalAccessTokens
   */
  listPersonalAccessTokens: {
    methodKind: "unary";
    input: typeof ListPersonalAccessTokensRequestSchema;
    output: typeof ListPersonalAccessTokensResponseSchema;
  },
  /**
   * CreatePersonalAccessToken creates a new Personal Access Token for a user.
   * The token value is only returned once upon creation.
   *
   * @generated from rpc journal.api.v1.UserService.CreatePersonalAccessToken
   */
  createPersonalAccessToken: {
    methodKind: "unary";
    input: typeof CreatePersonalAccessTokenRequestSchema;
    output: typeof CreatePersonalAccessTokenResponseSchema;
  },
  /**
   * DeletePersonalAccessToken deletes a Personal Access Token.
   *
   * @generated from rpc journal.api.v1.UserService.DeletePersonalAccessToken
   */
  deletePersonalAccessToken: {
    methodKind: "unary";
    input: typeof DeletePersonalAccessTokenRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * ListUserWebhooks returns a list of webhooks for a user.
   *
   * @generated from rpc journal.api.v1.UserService.ListUserWebhooks
   */
  listUserWebhooks: {
    methodKind: "unary";
    input: typeof ListUserWebhooksRequestSchema;
    output: typeof ListUserWebhooksResponseSchema;
  },
  /**
   * CreateUserWebhook creates a new webhook for a user.
   *
   * @generated from rpc journal.api.v1.UserService.CreateUserWebhook
   */
  createUserWebhook: {
    methodKind: "unary";
    input: typeof CreateUserWebhookRequestSchema;
    output: typeof UserWebhookSchema;
  },
  /**
   * UpdateUserWebhook updates an existing webhook for a user.
   *
   * @generated from rpc journal.api.v1.UserService.UpdateUserWebhook
   */
  updateUserWebhook: {
    methodKind: "unary";
    input: typeof UpdateUserWebhookRequestSchema;
    output: typeof UserWebhookSchema;
  },
  /**
   * DeleteUserWebhook deletes a webhook for a user.
   *
   * @generated from rpc journal.api.v1.UserService.DeleteUserWebhook
   */
  deleteUserWebhook: {
    methodKind: "unary";
    input: typeof DeleteUserWebhookRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * ListUserNotifications lists notifications for a user.
   *
   * @generated from rpc journal.api.v1.UserService.ListUserNotifications
   */
  listUserNotifications: {
    methodKind: "unary";
    input: typeof ListUserNotificationsRequestSchema;
    output: typeof ListUserNotificationsResponseSchema;
  },
  /**
   * UpdateUserNotification updates a notification.
   *
   * @generated from rpc journal.api.v1.UserService.UpdateUserNotification
   */
  updateUserNotification: {
    methodKind: "unary";
    input: typeof UpdateUserNotificationRequestSchema;
    output: typeof UserNotificationSchema;
  },
  /**
   * DeleteUserNotification deletes a notification.
   *
   * @generated from rpc journal.api.v1.UserService.DeleteUserNotification
   */
  deleteUserNotification: {
    methodKind: "unary";
    input: typeof DeleteUserNotificationRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_v1_user_service, 0);

